/**
 * Game SFX from S3 — regional URLs so staging can load the clips reliably.
 */

const BASE =
  "https://2023-extramileplay-php.s3.ap-south-1.amazonaws.com/UAT/snakes_ladders_react";

const SOURCES = {
  move: `${BASE}/timer.mp3`,
  ladder: `${BASE}/ladder.mp3`,
  snake: `${BASE}/snake.mp3`,
  dice: `${BASE}/dice-roll.mp3`,
  right: `${BASE}/awesome.mp3`,
  wrong: `${BASE}/wrong.mp3`,
};

const clips = {};
let hopStopTimer = null;

function getClip(type) {
  if (!SOURCES[type]) return null;
  if (!clips[type]) {
    clips[type] = new Audio(SOURCES[type]);
  }
  return clips[type];
}

/** Restart and play a clip. Failures (autoplay blocks) are swallowed. */
export function playGameAudio(type) {
  const audio = getClip(type);
  if (!audio) return;
  try {
    audio.pause();
    audio.currentTime = 0;
    const play = audio.play();
    if (play && typeof play.catch === "function") play.catch(() => {});
  } catch {
    /* ignore */
  }
}

/**
 * One hop of move SFX, lasting exactly `durationMs` so it lines up with the
 * token bounce. Call once per square — do not leave this looping.
 */
export function playHopAudio(durationMs) {
  if (hopStopTimer != null) {
    window.clearTimeout(hopStopTimer);
    hopStopTimer = null;
  }
  const audio = getClip("move");
  if (!audio) return;
  try {
    audio.loop = false;
    audio.pause();
    audio.currentTime = 0;
    const play = audio.play();
    if (play && typeof play.catch === "function") play.catch(() => {});
    hopStopTimer = window.setTimeout(() => {
      hopStopTimer = null;
      stopGameAudio("move");
    }, Math.max(0, durationMs));
  } catch {
    /* ignore */
  }
}

export function stopGameAudio(type) {
  if (type === "move" && hopStopTimer != null) {
    window.clearTimeout(hopStopTimer);
    hopStopTimer = null;
  }
  const audio = getClip(type);
  if (!audio) return;
  try {
    audio.pause();
    audio.currentTime = 0;
  } catch {
    /* ignore */
  }
}
